import { base } from './base';

export const kronoberg = Object.assign({}, base, {});
